import React from "react";
import { Route, Routes } from "react-router-dom";
import MainTextPage from "./MainTextPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditTextPage from "./AddEditTextPage";
import TextPageWrapper from "./TextPageWrapper";
import PageNotFound from "../PageNotFound";

const TextRouter: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute
            element={<TextPageWrapper Component={MainTextPage} />}
          />
        }
      />
      <Route
        path="create"
        element={
          <ProtectedRoute
            element={<TextPageWrapper Component={AddEditTextPage} />}
          />
        }
      />

      <Route
        path=":_id/edit"
        element={
          <ProtectedRoute
            element={<TextPageWrapper Component={AddEditTextPage} />}
          />
        }
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default TextRouter;
